import React, { PureComponent } from 'react';
import { Button, Label, Icon } from 'semantic-ui-react'
import NewEntryModal from './new_entry_modal'

class CollapsibleCard extends PureComponent {
  constructor(props){
    super(props)

    this.state = {
      expanded: this.props.expand === undefined? false: this.props.expand,
      isNewEntry: false,
      newEntryValue: "",
      newEntrySubmit: false,
    }
    this.creating = false
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      expanded: nextProps.expand === undefined? this.state.expanded: nextProps.expand,
    })

    if(this.creating && !nextProps.createPending) {
      this.creating = false
      this.setState({
        isNewEntry: false,
        newEntrySubmit: false,
        newEntryValue: "",
      })
    }
  }

  onNewEntrychange = (value) => {
    this.setState({
      newEntryValue: value,
    })
  }

  onCreateEntry = (parent) => {
    this.setState({
      isNewEntry: true,
      newEntryValue:"",
      newEntrySubmit: parent,
    })
  }

  onSubmitEntry = (formData, entryName) => {
    this.creating = true
    this.props.newEntry.callback(formData, entryName)
  }

  onToggle = () => {
    if(this.props.onToggle !== undefined) {
      this.props.onToggle(this.props.toggleKey)
    }
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    const { id, headerLabel, headerText, headerContent, className, content, newEntry, permission } = this.props
    const new_label = this.props.translations.new
    return (
      <div id={id} className="collapsible">
        <div className="collapsible header" onClick={ () => this.onToggle() }>
          <div className="collapsible-header-label">
            <Button icon={ this.state.expanded? "minus": "plus" } />
            <Label className={ "text " + className }>{ headerLabel }</Label>
          </div>
          <div className={"collapsible-header-text " + className}>
            { headerContent ? headerContent : headerText }
          </div>
        </div>
        {
          this.state.expanded &&
          <div className={ "collapsible content " + this.state.expanded }>
            { content }
            {
              (newEntry && permission && permission.can_update) &&
              <div className={ "collapsible" }>
                <div className="collapsible header" onClick={ () => this.onCreateEntry(headerText) }>
                  <div>
                    <div className="collapsible-new-entry">
                      <a className={ "collapsible-new-entry"}>
                        <Icon name={ "plus" } />
                        { new_label + " " + newEntry.name }
                      </a>
                    </div>
                  </div>
                  {
                    (this.state.newEntrySubmit === headerText) &&
                    <NewEntryModal
                      headerText={ new_label + " " + newEntry.name }
                      shown={ (this.state.newEntrySubmit === headerText)}
                      risk={ newEntry.risk }
                      onSubmit={this.onSubmitEntry}
                      onClose={ () => this.setState({newEntrySubmit: false}) }
                      translations={this.props.translations}
                      loading={this.props.createPending}
                      isTemplate={this.props.isTemplate}
                    />
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    )
  }
}

export default CollapsibleCard



// WEBPACK FOOTER //
// ./src/components/collapsible_card.js